import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GetStationeryCurrenciesQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetStationeryCurrenciesQuery = {
  __typename?: 'Query';
  currencyConversions: Array<{ __typename?: 'CurrencyConversion'; currencyCode: string; countryCodes: Array<string> }>;
};

export const GetStationeryCurrenciesDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetStationeryCurrencies' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currencyConversions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryCodes' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetStationeryCurrenciesQuery__
 *
 * To run a query within a React component, call `useGetStationeryCurrenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStationeryCurrenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStationeryCurrenciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStationeryCurrenciesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetStationeryCurrenciesQuery, GetStationeryCurrenciesQueryVariables>) {
  return ApolloReactHooks.useQuery<GetStationeryCurrenciesQuery, GetStationeryCurrenciesQueryVariables>(GetStationeryCurrenciesDocument, baseOptions);
}
export function useGetStationeryCurrenciesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStationeryCurrenciesQuery, GetStationeryCurrenciesQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetStationeryCurrenciesQuery, GetStationeryCurrenciesQueryVariables>(GetStationeryCurrenciesDocument, baseOptions);
}
export type GetStationeryCurrenciesQueryHookResult = ReturnType<typeof useGetStationeryCurrenciesQuery>;
export type GetStationeryCurrenciesLazyQueryHookResult = ReturnType<typeof useGetStationeryCurrenciesLazyQuery>;
export type GetStationeryCurrenciesQueryResult = Apollo.QueryResult<GetStationeryCurrenciesQuery, GetStationeryCurrenciesQueryVariables>;
